import {Directive, ElementRef, HostListener, Renderer2, Input} from '@angular/core';

@Directive({
    selector: '[stickyElement]',
    standalone: false
})
export class StickyElementDirective {
    @Input() isNotificationBar: boolean;
    constructor (private _elRef: ElementRef, private _renderer: Renderer2) {
    }
    
    @HostListener('window:scroll')
    checkScroll(){
        const navMain = this._elRef.nativeElement.querySelector('.nav-main');
        const navSticky = this._elRef.nativeElement.querySelector('.nav-sticky');
        // const pageTitle = document.querySelector('.page-title-container');
        const offsetnavMain = navMain.offsetTop + navMain.offsetHeight;
        
        if (window.pageYOffset > offsetnavMain) {
            this._renderer.addClass(navMain, 'hide-el');
            this._renderer.removeClass(navSticky, 'hide-el');
            // if(!this.isNotificationBar) TODO: uncomment this once the notification header feature is made present in production Materials App
                // this._renderer.removeClass(pageTitle, 'mt-5');
        }
        else {
            this._renderer.addClass(navSticky, 'hide-el');
            this._renderer.removeClass(navMain, 'hide-el');
            // if(!this.isNotificationBar) TODO: uncomment this once the notification header feature is made present in production Materials App
                // this._renderer.addClass(pageTitle, 'mt-5');
        }
    }
}
